import React, { useEffect, useState } from "react";
import "./styles/service.sass";
// import Slider from "./Slider";
import { useLocation } from "react-router-dom";

const Service = ({ title, description, image }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className='service'>
      <h1>{title}</h1>
      <img src={image} alt={title} />
      {/* <Slider slider ={false}/> */}
      <p>{description}</p>
    </div>
  );
};

export default Service;
